import { useState } from "react"
import { Box, Divider, Menu, MenuItem } from "@mui/material"
import LogoutIcon from "@mui/icons-material/Logout"
import { IProfileProps } from "./types"
import { Avatar } from "../../../basics"
import { AVATAR_SIZE, UserCard } from "../../../complex"
import { stringAvatar } from "src/lib/utils/strToAvatar"
import { useSidebarStore } from "src/store/sidebarStore"
import { useIsMobile } from "src/lib/hooks/useIsMobile"
import { COGNITO_CLIENT_ID, COGNITO_DOMAIN } from "src/config/configCognito"
import { SIDEBAR_WIDTH_EXPANDED } from "src/lib/consts/sidebarWidth"

const { REACT_APP_BASE_WEB_URL } = process.env

const signOutRedirect = () => {
    sessionStorage.clear()
    localStorage.clear()
    const logoutUri = `${REACT_APP_BASE_WEB_URL}/`
    window.location.href = `${COGNITO_DOMAIN}/logout?client_id=${COGNITO_CLIENT_ID}&logout_uri=${encodeURIComponent(logoutUri)}`
}

const Profile = ({ userName, userPosition, avatarName, menuOptions }: IProfileProps) => {
    const open = useSidebarStore((s: any) => s.open)
    const isMobile = useIsMobile()
    const [anchor, setAnchor] = useState<null | HTMLElement>(null)

    // no mobile a sidebar é um overlay sempre expandido
    const expanded = isMobile || open

    return (
        <>
            <Box
                onClick={(e) => setAnchor(e.currentTarget)}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "100%",
                    minWidth: 0,
                    justifyContent: expanded ? "flex-start" : "center",
                }}
                data-testid="user-informations"
            >
                {expanded ? (
                    <UserCard userName={userName} userPosition={userPosition} avatarName={avatarName ?? userName} />
                ) : (
                    <Avatar sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE, flexShrink: 0 }}>
                        {stringAvatar(avatarName ?? userName)}
                    </Avatar>
                )}
            </Box>
            <Menu
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={() => setAnchor(null)}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                transformOrigin={{ vertical: "bottom", horizontal: "left" }}
                marginThreshold={0}
                slotProps={{
                    paper: {
                        sx: {
                            backgroundImage: "none",
                            border: "1px solid rgba(255, 255, 255, 0.06)",
                            width: SIDEBAR_WIDTH_EXPANDED - 16,
                        },
                    },
                }}
            >
                {menuOptions && menuOptions.length > 0 && [
                    ...menuOptions.map((option) => (
                        <MenuItem
                            key={option.id}
                            selected={option.selected}
                            onClick={() => {
                                setAnchor(null)
                                option.onSelect()
                            }}
                            sx={{ fontWeight: 400 }}
                        >
                            {option.label}
                        </MenuItem>
                    )),
                    <Divider key="divider" />,
                ]}
                <MenuItem
                    onClick={() => {
                        setAnchor(null)
                        signOutRedirect()
                    }}
                    sx={{ fontWeight: 400 }}
                >
                    <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                    Sair
                </MenuItem>
            </Menu>
        </>
    )
}

export { Profile }
